// R27: Karussells wie Original (Shrine PRO setzt Splide 4 ein, Optionen aus dessen splide-component-Attributen).
// data-nb-kar = {"typ":"slide|loop","m":Karten mobil,"d":Karten Desktop,"gm":Abstand mobil,"gd":Abstand Desktop,"pm":Rand mobil,
//               "destroyD":true = Desktop festes Raster,"auto":Sekunden (0 = aus),"pfeile":true,"adaptiv":true}
(() => {
  if (window.__nbKar) return; window.__nbKar = true;
  const hoehe = s => { const a = s.Components.Slides.getAt(s.index); if (a) s.Components.Elements.list.style.height = a.slide.offsetHeight + 'px'; };
  const init = root => {
    if (root.__splide || typeof Splide === 'undefined') return;
    const d = JSON.parse(root.dataset.nbKar || '{}');
    const s = new Splide(root, {
      type: d.typ || 'slide', perPage: d.m || 1, perMove: 1, gap: d.gm ?? 15, padding: d.pm ? { left: d.pm, right: d.pm } : 0,
      arrows: d.pfeile !== false, pagination: false, drag: true, rewind: false, speed: 400,
      autoplay: !!d.auto, interval: (d.auto || 5) * 1000, pauseOnHover: false, pauseOnFocus: false,
      mediaQuery: 'min', breakpoints: { 750: d.destroyD ? { destroy: true } : { perPage: d.d || d.m || 1, gap: d.gd ?? 40, padding: d.pd ? { left: d.pd, right: d.pd } : 0 } }
    });
    if (d.adaptiv) s.on('mounted moved resized', () => hoehe(s));
    s.mount(); root.__splide = s;
  };
  const alle = () => document.querySelectorAll('.nb-kar[data-nb-kar]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  window.addEventListener('load', alle);
  document.addEventListener('shopify:section:load', alle);
})();
